module.exports = __webpack_public_path__ + "static/Flaticon-f4a1ea7ecfdc93271ec34bdccea07599.svg";